﻿import * as React from "react";
import { Radio as MaterialRadio, RadioProps, RadioGroup } from "@mui/material";
import { getDataProps, type WithDataProps } from "../../shared/utilities";

const Radio: React.FunctionComponent<WithDataProps<RadioProps>> = (props: WithDataProps<RadioProps>) =>
    <MaterialRadio
        icon={<span className="radio-button-container" />}
        checkedIcon={<span className="radio-button-container checked"><span className="radio-button-checked" /></span>}
        {...props}
        {...getDataProps(props)}
    />;

export { Radio, RadioGroup };
